var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping-cart"},_vm._l((_vm.items),function(item){return _c('CartItem',{key:item,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }